import { debouncer } from "../utility/utils";
import Dom from "../utility/dom";
import Modal from "./accessibility";
import { smoother } from "../utility/gsap";

export const initializeNav = (event) => {
  // Menu Toggle
  const nav = document.querySelector(".main-navigation");
  nav.isOpen = false;
  const menu_toggle = nav.querySelector(".menu-toggle");

  if (!!menu_toggle) {
    menu_toggle.addEventListener("click", function (e) {
      if (!nav.isOpen) {
        menuOpen();
      } else {
        menuClose();
      }
    });
  }

  const menuClose = () => {
    nav.isOpen = false;
    // Set closing class for css animation help
    nav.classList.add("closing");
    const navItems = nav.querySelectorAll("li");
    navItems.forEach((item) => {
      item.classList.add("closing");
    });
    setTimeout(() => {
      nav.classList.remove("closing");
      navItems.forEach((item) => {
        item.classList.remove("closing");
      });
    }, 700);

    // Set Active Class
    nav.classList.remove("toggled");
    menu_toggle.classList.remove("active");
    menu_toggle.blur();
    Dom.body.classList.remove("scroll-lock");
    Dom.body.classList.remove("nav_toggled");
    if (smoother) {
      smoother.paused(false);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute("aria-expanded", "false");

    // Handle focus trapping
    Modal.close(nav);
    menu_toggle.setAttribute("tabindex", "1");
  };

  const menuOpen = () => {
    nav.isOpen = true;

    // Set Active Class
    nav.classList.add("toggled");
    Dom.body.classList.add('nav_toggled');
    menu_toggle.classList.add("active");
    menu_toggle.blur();
    Dom.body.classList.add("scroll-lock");
    if (smoother) {
      smoother.paused(true);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute("aria-expanded", "true");

    // Handle focus trapping
    Modal.open(nav);
  };

  // Mobile Sub-Menu Toggling
  const sub_menu_links = nav.querySelectorAll('li:has(.sub-menu) > a');
  sub_menu_links.forEach((link) => {
    link.addEventListener("click", function (e) {
      // If mobile menu is open
      if (nav.isOpen) {
        e.preventDefault();
        const sub_menu = this.nextElementSibling;
        if (sub_menu) {
          sub_menu.classList.toggle("toggled");
          sub_menu.setAttribute("aria-hidden", !is_open);
        }
      }
    });
  });

  // Set menu state on load and resize if changing from mobile to desktop.
  function set_menu_state() {
    // Since we don't know the menu breakpoint, check if the menu toggle is visible
    const is_desktop = menu_toggle.offsetParent === null ? true : false;

    // Desktop
    if (is_desktop) {
      if (!nav.classList.contains("is_desktop")) {
        nav.classList.add("is_desktop");
        nav.classList.remove("is_mobile");
      }

      // if mobile state classes are present, remove them.
      if (nav.classList.contains("toggled")) {
        menuClose();
        Modal.setToFocusable(nav);
        Dom.body.classList.remove('nav_toggled');
        
        const sub_menus = nav.querySelectorAll(".sub-menu.toggled");
        if(sub_menus.length){
          sub_menus.forEach((sub_menu) => {
            sub_menu.classList.remove("toggled");
            sub_menu.removeAttribute("aria-hidden",);
          });
        }
      }

      // set aria-hidden if not already set to false
      if (menu_toggle.getAttribute("aria-expanded") !== "true") {
        menu_toggle.setAttribute("aria-expanded", "true");
      }
    }
    // Mobile
    else {
      if (!nav.classList.contains("is_mobile")) {
        nav.classList.remove("is_desktop");
        nav.classList.add("is_mobile");
      }

      // set aria-hidden if not already set to true and if menu isn't currently active
      if (!nav.classList.contains("toggled") && menu_toggle.getAttribute("aria-expanded") !== "false") {
        menu_toggle.setAttribute("aria-expanded", "false");
      }
    }
  }
  set_menu_state();

  // Resize modals on window resize
  window.addEventListener(
    "resize",
    debouncer(function () {
      set_menu_state();
    }, 15)
  );
};
